/*
 * Confidential and Proprietary.
 * Do not distribute without 1-800-Flowers.com, Inc. consent.
 * Copyright 1-800-Flowers.com, Inc. 2019. All rights reserved.
 */

import React, {
    useEffect, useState,
} from 'react';
import { ClickAwayListener, Popper, makeStyles } from '@material-ui/core';
import { useDispatch } from 'react-redux';
import {
    arrayOf, bool, number, object, shape,
    string,
} from 'prop-types';
import PriceShownDetail from './PriceShownDetail';
import { trackEvent } from '../../../../../../../../../state/ducks/TagManager/ducks/TagManager/TagManager-Actions';

const useStyles = makeStyles(() => ({
    container: {
        position: 'relative',
    },
    popperRoot: {
        zIndex: 9999,
    },
    priceShown: {
        overflow: 'hidden',
        textOverflow: 'ellipsis',
        fontSize: '14px',
        fontStyle: 'normal',
        fontWeight: '500',
        lineHeight: '18px',
        letterSpacing: '0.12px',
        textDecorationLine: 'underline',
        textDecorationStyle: 'solid',
        textDecorationSkipInk: 'auto',
        textDecorationThickness: 'auto',
        textUnderlineOffset: 'auto',
        textUnderlinePosition: 'from-font',
        cursor: 'pointer',
        '@media only screen and (max-width: 768px)': {
            lineHeight: '16px !important',
            fontSize: '12px !important',
        },
    },
}));

const PriceShownUi = ({
    skuPriceRange, partNumber, displayPrice,
}) => {
    if (!skuPriceRange) { return null; }
    const classes = useStyles();
    const [isOpen, setOpen] = useState(false);
    const [anchorEl, setAnchorEl] = useState(null);
    const dispatch = useDispatch();

    const openPriceDialog = (event) => {
        event?.preventDefault();
        event?.stopPropagation();
        setAnchorEl(event?.currentTarget);
        setOpen(!isOpen);
        if (!isOpen) {
            dispatch(trackEvent({
                eventCategory: 'Collection',
                eventAction: 'Click',
                eventLabel: 'Price as shown',
                feature_detail: 'Price as shown',
                feature_element: 'Click',
                feature_category: 'Collection',
            }));
        }
    };

    useEffect(() => {
        if (typeof document !== 'undefined' && skuPriceRange && typeof window !== 'undefined') {
            const scrollbarWidth = window.innerWidth - document.documentElement.clientWidth;
            if (anchorEl) {
                document.body.setAttribute('style', `overflow: hidden; padding-right: ${scrollbarWidth}px;`);
            } else {
                document.body.setAttribute('style', 'overflow: auto;');
            }
        }
    }, [anchorEl]);

    const productMessageCopyTitle = () => (
        <div role="presentation" aria-label="Click here to open popper" onClick={(e) => openPriceDialog(e)} className={classes.priceShown}>
            See price as shown
        </div>
    );

    return (
        <div
            className={`${classes.container}`}
            role="presentation"
            onClick={(e) => {
                if (isOpen) {
                    e.stopPropagation();
                }
            }}
            onMouseDown={(e) => {
                if (isOpen) {
                    e.stopPropagation();
                }
            }}
        >
            {productMessageCopyTitle()}
            {isOpen
                ? (
                    <div className={classes.container}>
                        <ClickAwayListener
                            mouseEvent="onMouseDown"
                            touchEvent="onTouchStart"
                            onClickAway={() => {
                                setOpen(false);
                                if (typeof document !== 'undefined') {
                                    document.body.removeAttribute('style', 'overflow');
                                }
                                setAnchorEl(null);
                            }}
                        >
                            <Popper
                                className={classes.popperRoot}
                                open={isOpen}
                                anchorEl={anchorEl}
                                transition
                                placement="bottom-start"
                            >
                                <PriceShownDetail
                                    openPriceDialog={openPriceDialog}
                                    showSinglePrice={false}
                                    skuPriceRange={skuPriceRange}
                                    partNumber={partNumber}
                                    displayPrice={displayPrice}
                                />
                            </Popper>
                        </ClickAwayListener>
                    </div>
                )
                : <></>}
        </div>

    );
};

PriceShownUi.propTypes = {
    partNumber: string.isRequired,
    skuPriceRange: shape({
        retail: arrayOf(shape({
            value: number,
        })),
        sale: arrayOf(shape({
            value: number,
        })),
    }),
    displayPrice: bool.isRequired,
};
PriceShownUi.defaultProps = {
    skuPriceRange: {},
};

export default PriceShownUi;
